import React, { useEffect, useState } from 'react';
import { makeStyles, useTheme } from '@mui/styles';
import clsx from 'clsx';

import { yellow } from '../../../data/colors';

import Grid from '@mui/material/Grid';

import Moment from 'moment';
import { get as _get } from 'lodash';
import { format as D3format } from 'd3';
import { GridToolbarContainer, useGridApiContext } from '@mui/x-data-grid-pro';

const useStyles = makeStyles(theme => ({
    footer: {
        ...theme.typography.caption,
        display: 'flex',
        paddingLeft: 10,
        paddingRight: 10,
    },
    refresh: {
        textShadow: `0 0 10px ${theme.palette.primary.contrastText}, 0 0 20px ${yellow[400]}`,
    },
    asof: {
        transition: '500ms',
        transitionProperty: 'text-shadow, font-weight',
    },
}));

const TableFooter = () => {
    const apiRef = useGridApiContext();
    // const [state] = useGridState(apiRef);
    const { state } = apiRef.current;
    const classes = useStyles();
    const theme = useTheme();

    const [refreshed, setRefreshed] = useState(false);

    const total = () => {
        let total = _get(state, 'params.total', 0);
        const totals = D3format(',.0f')(total);
        if (total > 0 && total < state.params.total) total = state.params.total;
        return total > 0
            ? total === 10000 ? 'of more than ' + totals : 'of ' + totals
            : '';
    };

    const msg = () => {
        return _get(state, 'params.msg', '');
    };

    const asof = () => {
        const asof = _get(state, 'params.asof');
        return asof ? 'Data as of ' + Moment(asof).format(theme.date.long) : '';
    };

    // gui indicator when 'asof' was updated
    useEffect(() => {
        setRefreshed(true);
        setTimeout(() => setRefreshed(false), 2000);
    }, [state.params.asof]);

    return (
        <GridToolbarContainer>
            <Grid container spacing={2} className={classes.footer} justifyContent="space-between">
                <Grid item className={clsx(classes.asof, refreshed && classes.refresh)}> {asof()} </Grid>
                <Grid item> {msg()} </Grid>
                <Grid item>
                    Listing Rows 1 - {state.rows.totalRowCount} {total()}
                </Grid>
            </Grid>
        </GridToolbarContainer>
    );
};

export {
    TableFooter as default,
};
